/**
 * C1 (17-SET-2026): `ScrollArea` (Shadcn/Radix) passa el `ref` a l'arrel, que és
 * `overflow-hidden`: posar-hi `scrollTop` no fa res. El contenidor que fa scroll és el
 * Viewport de dins, marcat per Radix amb `data-radix-scroll-area-viewport`.
 */
export const SCROLL_AREA_VIEWPORT_SELECTOR = '[data-radix-scroll-area-viewport]';

type ScrollableElement = Pick<HTMLElement, 'scrollTop' | 'scrollHeight'>;
type ScrollRoot = ScrollableElement & {
  querySelector: (selector: string) => ScrollableElement | null;
};

export function scrollViewportToBottom(root: ScrollRoot | null): void {
  if (!root) return;
  const target = root.querySelector(SCROLL_AREA_VIEWPORT_SELECTOR) ?? root;
  target.scrollTop = target.scrollHeight;
}
